module.exports = __webpack_public_path__ + "static/media/logo.49b1e8be.png";